export const materialUIThemeUserDashboard = {
  overrides: {
    MuiTableCell: {
      sizeSmall: {
        padding: '6px 10px',
      },
    },
  },
};
